import React from 'react';
import { Button, Flex } from '@chakra-ui/react';

const tabData = [
    {
        id: 'stations',
        title: 'Stations',
    },
    {
        id: 'forecasts',
        title: 'Forecasts',
    },
    {
        id: 'parameters',
        title: 'Parameters',
    },
];

const MapTabs = (props) => {
    const { currentTab, onTabChange } = props;

    return (
        <div style={{ position: 'fixed', bottom: 0, zIndex: 12, width: '100%' }}>
            <Flex bg='#fff' align='center' justify='center' className="map-nav">
                {tabData.map((tab) => (
                    <Button
                        key={tab.id}
                        variant='solid'
                        onClick={() => onTabChange(tab.id)}
                        borderRadius='99px'
                        bg={currentTab === tab.id ? 'teal.100' : ''}
                        color={currentTab === tab.id ? 'teal.700' : 'gray.800'}
                        fontWeight={500}
                        size='lg'
                        _hover={{
                            bg: 'teal.200',
                        }}
                        _focus={{
                            bg: 'teal.200',
                        }}
                        _active={{
                            bg: 'teal.200',
                        }}
                    >
                        {tab.title}
                    </Button>
                ))}
            </Flex>
        </div>
    );
};

export default MapTabs;
